import { siteData } from '../../data/mock';

export const Footer = () => {
  return (
    <>
      {/* Marquee */}
      <div className="bg-[#0A0A0A] border-t border-white/[0.03] overflow-hidden py-5">
        <div className="marquee-track flex items-center whitespace-nowrap">
          {Array.from({ length: 10 }).map((_, i) => (
            <span
              key={i}
              className="font-serif text-[46px] md:text-[60px] text-white/[0.03] uppercase tracking-[0.08em] mx-6 select-none"
            >
              All The Details
              <span className="text-[#C4A265]/10 mx-8 inline-block">
                &mdash;
              </span>
            </span>
          ))}
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#070707] py-10">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-16">
          <div className="flex flex-col md:flex-row items-center justify-between gap-5">
            <div className="flex items-center gap-6">
              <span className="font-serif text-lg tracking-wide text-[#F5F1EC]">
                <span className="font-light">All The</span>{' '}
                <span className="font-semibold italic text-[#C4A265]">
                  Details
                </span>
              </span>
              <span className="hidden md:inline text-white/[0.08]">|</span>
              <a
                href={`mailto:${siteData.email}`}
                className="text-[#8A8580] hover:text-[#C4A265] text-xs tracking-wide transition-colors duration-300"
              >
                {siteData.email}
              </a>
            </div>

            <p className="text-[#444] text-[11px] tracking-wide">
              &copy; {new Date().getFullYear()} All The Details &mdash; Founded
              1994 &mdash; {siteData.website}
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};
